module.exports = __webpack_public_path__ + "static/about-8c6db11b062baadefd00f24d24872e12.jpg";